<script>
  import { showFeatureInfo } from '../stores/configStore';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faTimes } from '@fortawesome/pro-light-svg-icons';
  
  // Props for customizing the component per page
  export let title = "Feature Information";
  export let description = "This page allows you to work with data in the system.";
  export let marginBottom = "mb-2"; // Added parameter with default of mb-2
  export let descriptionClass = '';
  
  function hideFeatureInfo() {
    showFeatureInfo.set(false);
  }

  // Convert newlines to <br> tags and wrap asterisked text in bold tags
  $: formattedDescription = description
    .replace(/\n/g, '<br>')
    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
</script>

{#if $showFeatureInfo}
  <div class="mx-1 mt-2 {marginBottom} p-4 rounded-lg shadow-md bg-stone-100/60 dark:bg-gray-800/60 border border-orange-300 dark:border-cyan-600 relative">
    <button 
      class="absolute top-2 right-3 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
      on:click={hideFeatureInfo}
      title="Hide feature information"
    >
      <FontAwesomeIcon icon={faTimes} size="sm" />
    </button>
    <div class="flex flex-col">
      <div class="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-2">{title}</div>
      <div class={`text-xs text-gray-700 dark:text-gray-300 ${descriptionClass}`}>{@html formattedDescription}</div>
    </div>
  </div>
{/if} 